import React, { useEffect, useState, useRef } from "react";
import InboxList from '../../../globalcomponents/inboxList';
import EmailDetail from '../../../globalcomponents/inboxDetail';
import SentList from '../../../globalcomponents/sentList';
import SentDetail from '../../../globalcomponents/sentDetail';
import EmailComposer from '../../../globalcomponents/emailComposer/emailComposer';
import { withRouter } from 'react-router-dom';
import { genericApi, fileUpload, getFiles } from '../../../common/apiconfig';
import deleteIcon from '../../../img/delete-icon.svg'
import { useConfirm } from "material-ui-confirm";
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHoc from '../../../globalcomponents/hoc/formHoc';
import Snackbar from '../../../common/snackbar';
import { connect } from 'react-redux';
import JoditEditor from "jodit-react";
import { editorConfig } from '../../../common/constants';
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment';
import clsx from "clsx";
import { isPKCETransactionMeta } from "@okta/okta-auth-js";


const useStyles = makeStyles(theme => ({
  sidebar: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 'full'
  },
  sidebarButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    marginBottom: theme.spacing(1),

    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    }
  },
  sidebarButtonActive: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: theme.palette.action.selected,
    }
  }
}));


const Email = (propsobj) => {
    console.log(propsobj.formValues,"Formmm")
  const classes = useStyles();
  const [progress, setProgress] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 10;
  const [inputValue, setInputValue] = useState("");
  const [usersValue, setUsersValue] = useState([]);
  const [open, setOpen] = useState(false)
  const [variant, setVariant] = React.useState("")
  const [msg, setMsg] = useState("")
  const [data, setData] = useState("");
  const [todata, setToData] = useState([]);
  const [ccData, setCcData] = useState([]);
  const [ccInputValue, setCcInputValue] = useState('');
  const [ccUsersValue, setCcUsersValue] = useState([]);
  const [CCdata, setCCdata] = useState([]);
  const [BCCdata, setBCCdata] = useState([]);
  const [hideccbtn, setHideccbtn] = useState(true);
  const [showcc, setShowcc] = useState(false);
  const [hidebccbtn, setHidebccbtn] = useState(true);
  const [showbcc, setShowbcc] = useState(false);
  const [content, setContent] = useState('');
  const [templateData, setTemplateData] = useState([]);
  const [templateId, settemplateId] = useState({});
  const [showNewMail, setShowNewMail] = useState(false);
  const [showInbox, setShowInbox] = useState(true);
  const [showSent, setShowSent] = useState(false);
  const [selectedInboxEmail, setSelectedInboxEmail] = useState(null);
  const [selectedSentEmail, setSelectedSentEmail] = useState(null);
  const [activeTab, setActiveTab] = useState("new");
  const [inboxData, setInboxData] = useState([]);
  const [sentMailData, setSentMailData] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [forward, setForward] = useState(false);
  const [replyAll, setReplyAll] = useState(false);
  const [reply, setReply] = useState(false);
  const [subject, setSubject] = useState('');
  const [toIds, setToIds] = useState([]);
  const [ccIds, setCcIds] = useState([]);
  const formattedAttachments = attachments.map(att => {
    const id = att.file_id || att.Id;
    const fileName = att.file_name || att.filename;
    return `{Id:"${id}",filename:"${fileName}"}`
  }).join(", ");
  const removeAttachment = (fileId) => {
    setAttachments((prev) => prev.filter(file => (file.file_id || file.Id) !== fileId));
  };


  const editor = useRef(null);
  useEffect(() => {
    propsobj.UpdateFormField({ name: "fromtext", value: localStorage.getItem("loggedUserEmail") });
    propsobj.UpdateFormField({ name: "ipSubject", value: "" });
    // callGetTemplatesApi();
    getMails();
    getSentMails();
    getApiData();
    setSelectedSentEmail(false);
    setSelectedInboxEmail(false);
  }, [propsobj.formValues.patientStudyInfo?.studyID, pageNumber]);

  const hocObj = FormHoc(propsobj);

  const textProps = {
    ...hocObj,
    propsobj
  };


  async function getApiData() {
    let {studyID, siteID}= propsobj.formValues.patientStudyInfo
    let requestBody = {
      query:  `query {
            getStudySiteContact(studyId: "${studyID}", siteId: "${siteID}") {
              studyId
              siteId
              contactId
              contactName
              role
              primaryContactInd
              email
              phone
              status
              createdBy
              createdTs
              modifiedBy
              modifiedTs
                    }
                  }`
    };

    requestBody = JSON.stringify(requestBody);
    setProgress(true);
    let res = await genericApi('getStudySiteContact', requestBody);
    setProgress(false);
    if (!res) {
      // Error handling
      //console.log('Error')

    } else {
      if (res?.data?.getStudySiteContact?.length>0) {
        setData(res?.data?.getStudySiteContact)
      } else {
        setData([])
      }
    }
  }



  const getMails = async () => {
    let requestBody = `
    query {
      getStudySiteEmails(
        userId:"${localStorage.getItem('loginUserId')}",
        userType:"${localStorage.getItem('whichApp')}",
        studyId: "${propsobj.formValues.patientStudyInfo?.studyID}",
        siteId: "${propsobj.formValues.patientStudyInfo?.siteID}",
        fromType: "Site",
        toType: "Patient",
        searchStr: "*",
        pageSize: ${pageSize},
        pageNumber: ${pageNumber} ,
      ) {
        emailId
        fromUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        toUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        ccUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        emailSubject
        emailBody
        createdBy
        timeStamp
        studyId
        siteId
        fromType
        toType
        attachments {
           file_id
           file_name
         }

      }
    }
  `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await genericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {
      setInboxData(res);

    } else {
      console.error("Failed to fetch study site emails.");
    }
  };

  const getSentMails = async () => {
    const { autostudy, autosite } = propsobj.formValues;
    let requestBody = `
      query {
        getStudySiteEmails(
          userId:"${localStorage.getItem('loginUserId')}",
          userType:"${localStorage.getItem('whichApp')}",
          studyId: "${propsobj.formValues.patientStudyInfo?.studyID}",
          siteId:"${propsobj.formValues.patientStudyInfo?.siteID}",
          fromType: "Patient",
          toType: "Site",
          searchStr: "*"
        ) {
          emailId
          fromUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          toUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          ccUser {
            sponsorAccountUserId
            sponsorAccountId
            SponsorAccountName
            firstName
            middleName
            lastName
            email
            phone
            roleId
            role
            language
            portalAccessInd
            invitedBy
            invitedDate
            activated
            primaryContactInd
            createdBy
            createdTs
            modifiedBy
            modifiedTs
            position
          }
          emailSubject
          emailBody
          createdBy
          timeStamp
          studyId
          siteId
          fromType
          toType
          attachments {
           file_id
           file_name
         }
        }
      }
    `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await genericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {

      setSentMailData(res);

    } else {
      console.error("Failed to fetch study site emails.");
    }
  };



  const autoPropstotemplates = {
    options: templateData,
    default: null,
    freeSolo: false,
    propsobj,
    keys: ['value']
  };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);

    for (let file of files) {

      const res = await fileUpload("file-upload", JSON.stringify({ filename: file.name }));
      setProgress(true);
      if (res?.code === 200 && res?.attributes) {
        const { Id, URL } = JSON.parse(res.attributes);
        const blob = new Blob([file]);
        const putResponse = await fetch(URL, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
          },
          body: blob,
        });
        if (putResponse.status === 200) {
          setAttachments(prev => [...prev, { Id, filename: file.name, URL }]);
          setProgress(false);
        } else {
          alert(`Upload failed for ${file.name}`);
        }
      } else {
        alert("Failed to get upload URL.");
      }
    }
    e.target.value = "";
  };

  const download = async (e, file) => {
    e.preventDefault();
    const requestData = {
      detail1: file.file_id,
      detail2: file.file_name
    };

    const res = await getFiles('fileupload', requestData, "GET");
    if (res.code === 200) {
      const data = JSON.parse(res.attributes);
      try {
        const response = await fetch(data.URL);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error("Download failed", err);
      }
    } else {
      console.error("Failed to get presigned URL", res);
    }
  };
  const confirm = useConfirm();
  const handleClick = () => {
    confirm({ description: 'Are you sure you want to discard this draft?' })
      .then(() => deleteEmail())
      .catch(() => {
        // Optional: handle cancel or errors here if needed
      });
  };

  const deleteEmail = () => {
    setAttachments([]);
    setToData([]);
    setCcData([]);
    setBCCdata([]);
    setHideccbtn(true);
    setShowcc(false);
    setContent("");
    if (editor.current) {
      editor.current.value = "";
    }
    settemplateId({});
    propsobj.UpdateFormField({ name: "useTemplate", value: "" });
    propsobj.UpdateFormField({ name: "ipSubject", value: "" });
    setForward(false);
    setShowInbox(true);
    setShowNewMail(false);
    setReplyAll(false);
    setReply(false);
    setShowSent(false);
    setSelectedSentEmail(false);
  };
  const sendInvite = async (e) => {
    e.preventDefault();
    const stringifyTodata = todata.map(item => `"${item}"`);
    const stringifyCCdata = CCdata.map(item => `"${item}"`);
    const stringifyBCCdata = BCCdata.map(item => `"${item}"`);
    if (propsobj.formValues.fromtext && stringifyTodata.length > 0) {
      const {siteID, studyID} = propsobj.formValues.patientStudyInfo;
      const contactIds = usersValue.map(item => `"${item.id}"`);
      const cleanedCcContactIds = ccData
        .map(c => `"${c.id}"`)
        .filter(id => id !== '"undefined"' && id !== '"null"');
      const ccContactIds = cleanedCcContactIds.length > 0 ? cleanedCcContactIds : [];
      const finalToIds = contactIds.length ? contactIds : toIds.map(id => `"${id}"`);
      const finalCcIds = ccContactIds.length ? ccContactIds : ccIds.map(id => `"${id}"`);
      const rawHtml = content || "";
      const fromType = "Patient";
      const toType = "Site";
      const requestBody = JSON.stringify({
        query: `mutation {
        sendEmailsWithAttachments(
          fromId: "${localStorage.getItem('loginUserId')}",
          toId: [${finalToIds}],
          ccId: [${finalCcIds}],
          bccId: [${stringifyBCCdata}],
          emailSubject: "${propsobj.formValues.ipSubject}",
          emailBody:${JSON.stringify(rawHtml)},
          bulkMail: "Y",
          studyId: "${studyID}",
          siteId: "${siteID}",
          fromType: "${fromType}",
          toType: "${toType}",
          attachmentList:  [${formattedAttachments}],
        ) {
          code
          type
          message
          attributes
        }
      }`
      });

      setProgress(true);
      const res = await genericApi("sendEmailsWithAttachments", requestBody);
      setProgress(false);

      if (res?.data?.sendEmailsWithAttachments?.code === "200") {
        setOpen(true)
        setVariant('success')
        setMsg(res?.data?.sendEmailsWithAttachments?.message)
        setAttachments([]);
        setToData([]);
        setCcData([]);
        setBCCdata([]);
        setHideccbtn(true);
        setShowcc(false);
        setContent("");
        if (editor.current) {
          editor.current.value = "";
        }
        settemplateId({});
        getSentMails();
        propsobj.UpdateFormField({ name: "useTemplate", value: "" });
        propsobj.UpdateFormField({ name: "ipSubject", value: "" });
        setForward(false);
        setReplyAll(false);
        setShowNewMail(false);
        setShowSent(true);
        setShowInbox(false);
        setSelectedInboxEmail(false);
      } else {
        alert("Failed to send invite.");
      }
    } else {
      alert('Please Enter From and To');
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    propsobj.history.goBack();
  };

  const handleTemplates = (obj) => {
    settemplateId(obj.selected);
    propsobj.UpdateFormField({ name: obj.name, value: obj.selected });
    setContent(obj.selected.body);
  };


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const formatDate = (timestamp) => {
    return moment(timestamp).format("MMM DD/YY");
  };

  const getSuggestions = (input) => {
    const query = input.toLowerCase();

    const contacts = Array.isArray(data) ? data : [];

    return contacts
      .filter((c) => c.contactName.toLowerCase().includes(query))
      .map((c) => ({
        label: `${c.contactName} <${c.email}>`,
        value: c.email,
        id: c.contactId,
      }));
  };

  const handleDelete = () => {
    setOpen(true)
    setVariant('success')
    setMsg("Email deleted successfully")
    getMails();
    getSentMails();
  }
  const handleNewMail = () => {
    setShowInbox(false);
    setShowSent(false);
    setShowNewMail(true);
    setSelectedInboxEmail(false);
    setSelectedSentEmail(null);
    setForward(false);
    setReply(false);
    setReplyAll(false);
    setAttachments([]);
    setToData([]);
    setCcData([]);
    setBCCdata([]);
    setContent("");
    propsobj.UpdateFormField({ name: "ipSubject", value: "" });

  }

  const handleOpenInbox = () => {
    setShowNewMail(false);
    setShowInbox(true);
    setShowSent(false);
    setSelectedInboxEmail(null);
    setSelectedSentEmail(null);
  }

  const handleOpenSent = () => {
    setActiveTab("sent");
    setShowInbox(false);
    setShowNewMail(false);
    setShowSent(true);
    setSelectedInboxEmail(null);
    setSelectedSentEmail(null);
    setForward(true);
    setReplyAll(false);
  };

  const handleForwardMail = (emailData) => {
    setContent(emailData.
      emailBody);
    propsobj.UpdateFormField({ name: "ipSubject", value: emailData.emailSubject });
    setAttachments(emailData.attachments);
    setShowNewMail(true);
    setShowInbox(false);
    setSelectedInboxEmail(false);
    setForward(true);
    setShowSent(false);
    setSelectedSentEmail(false);
    setReplyAll(false);
    setReply(false);
  }

  const handleReplyAll = (emailData) => {
    const fromUsers = Array.isArray(emailData.fromUser)
      ? emailData.fromUser
      : [emailData.fromUser];

    const toMapped = fromUsers.map((item) => ({
      label: item.email,
      value: item.email,
      id: item.sponsorAccountUserId,
    }));

    const ccMapped = emailData.ccUser.map((item) => ({
      label: item.email,
      value: item.email,
      id: item.sponsorAccountUserId,
    }));

    setToData(toMapped);
    setCcData(ccMapped);
    setUsersValue(toMapped);
    setCcUsersValue(ccMapped);
    setToIds(toMapped.map(item => item.id));
    setCcIds(ccMapped.map(item => item.id));
    setAttachments(emailData.attachments);
    propsobj.UpdateFormField({ name: "ipSubject", value: emailData.emailSubject });
    setShowNewMail(true);
    setReplyAll(true);
    setForward(false);
  };


  const handleReply = (emailData) => {
    console.log(emailData, "emailData")
    const fromUsers = Array.isArray(emailData.fromUser)
      ? emailData.fromUser
      : [emailData.fromUser];

    const toMapped = fromUsers.map((item) => ({
      label: item.email,
      value: item.email,
      id: item.sponsorAccountUserId,
    }));

    const ccMapped = emailData.ccUser.map((item) => ({
      label: item.email,
      value: item.email,
      id: item.sponsorAccountUserId,
    }));
    setToData(toMapped);
    // setCcData(ccMapped);
    setUsersValue(toMapped);       // important for your sendInvite to use correct contactIds
    // setCcUsersValue(ccMapped);
    setToIds(toMapped.map(item => item.id));
    setCcIds(ccMapped.map(item => item.id));
    setAttachments(emailData.attachments);
    propsobj.UpdateFormField({ name: "ipSubject", value: emailData.emailSubject });
    setShowNewMail(true);
    setReplyAll(false);
    setForward(false);
    setReply(true);
  }

  return (
    <>
      {progress && (
        <div className="fullScreen">
          <CircularProgress className="progressCircle" size={100} thickness={1.5} />
        </div>
      )}
      <Snackbar open={open} variant={variant} message={msg} handleClose={handleClose} />

      <Grid container className={classes.root} spacing={2} style={{ marginTop: '10px' }}>
        {/* Sidebar */}
        <Grid item xs={12} sm={12} md={2}>
          <Paper className={classes.sidebar}>
            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "new"
              })}
              startIcon={<AddIcon />}
              onClick={() => { setActiveTab("new"); handleNewMail(); }}
              fullWidth
            >
              New Mail
            </Button>

            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "inbox"
              })}
              onClick={() => { setActiveTab("inbox"); handleOpenInbox(); }}
              fullWidth
            >
              Inbox
            </Button>

            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "sent"
              })}
              onClick={handleOpenSent}
              fullWidth
            >
              Sent Items
            </Button>
          </Paper>
        </Grid>
        <InboxList
          showInbox={showInbox}
          selectedEmail={selectedInboxEmail}
          showNewMail={showNewMail}
          mailData={inboxData}
          pageNumber={pageNumber}
          pageSize={pageSize}
          setPageNumber={setPageNumber}
          setSelectedEmail={setSelectedInboxEmail}
          setShowNewMail={setShowNewMail}
          formatDate={formatDate}
          onDelete={handleDelete}
        />
        {/* Composer shown independently for New Mail */}
        {showNewMail && !replyAll && !reply && (!forward || forward) && (
          <Grid item xs={12} md={10}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              height: 'auto',
              overflowY: 'auto',
              padding: '0px',
              backgroundColor: '#fff'
            }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  backgroundColor: '#D3D3D3',
                  padding: '5px 10px',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Typography variant="h6" style={{ margin: 5 }}>
                  {forward ? 'Forward' : 'New Message'}
                </Typography>
                <img
                  src={deleteIcon}
                  alt="deleteMail"
                  height="24"
                  width="24"
                  onClick={handleClick}
                  style={{ cursor: 'pointer' }}
                />
              </div>

              <EmailComposer
                textProps={textProps} bn
                todata={todata}
                setToData={setToData}
                inputValue={inputValue}
                setInputValue={setInputValue}
                getSuggestions={getSuggestions}
                ccData={ccData}
                setCcData={setCcData}
                ccInputValue={ccInputValue}
                setCcInputValue={setCcInputValue}
                setUsersValue={setUsersValue}
                setCcUsersValue={setCcUsersValue}
                subject={subject}
                setSubject={setSubject}
                content={content}
                setContent={setContent}
                attachments={attachments}
                handleFileChange={handleFileChange}
                removeAttachment={removeAttachment}
                download={download}
                sendInvite={sendInvite}
              />
            </div>
          </Grid>
        )}
        {selectedInboxEmail && (
          <Grid item xs={12} md={7}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'auto',
                overflowY: 'auto',
                padding: '0px',
                backgroundColor: '#fff'
              }}
            >
              {showNewMail && (
                <div
                  style={{
                    marginTop: '0px',
                    overflowX: 'auto',
                    minWidth: 'auto',
                    // borderTop: '1px solid #ddd',
                    paddingTop: '0px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      backgroundColor: '#D3D3D3',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="h6" style={{ paddingLeft: '6px', paddingRight: '6px' }}>
                      {forward ? 'Forward' : replyAll ? 'Reply All' : 'Reply'}
                    </Typography>
                    <img
                      src={deleteIcon}
                      alt="deleteMail"
                      height="24"
                      width="24"
                      onClick={handleClick}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>

                  <EmailComposer
                    textProps={textProps}
                    todata={todata}
                    setToData={setToData}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    getSuggestions={getSuggestions}
                    ccData={ccData}
                    setCcData={setCcData}
                    ccInputValue={ccInputValue}
                    setCcInputValue={setCcInputValue}
                    setUsersValue={setUsersValue}
                    setCcUsersValue={setCcUsersValue}
                    subject={subject}
                    setSubject={setSubject}
                    content={content}
                    setContent={setContent}
                    attachments={attachments}
                    handleFileChange={handleFileChange}
                    removeAttachment={removeAttachment}
                    download={download}
                    sendInvite={sendInvite}
                  />
                </div>
              )}
              {/* Email Detail */}
              <div style={{ width: '100%' }}>
                <EmailDetail
                  selectedEmail={selectedInboxEmail}
                  formatDate={formatDate}
                  onClose={() => setSelectedInboxEmail(null)}
                  inboxProps={handleForwardMail}
                  replyAllProps={handleReplyAll}
                  replyProps={handleReply}
                />
              </div>
            </div>
          </Grid>
        )}
        <SentList
          showSent={showSent}
          selectedEmail={selectedSentEmail}
          mailData={sentMailData}
          setSelectedEmail={setSelectedSentEmail}
          formatDate={formatDate}
          onDelete={handleDelete}
        />
        {selectedSentEmail && (
          <Grid item xs={12} md={7}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: 'auto',
                overflowY: 'auto',
                padding: '0px',
                backgroundColor: '#fff'
              }}
            >
              {showNewMail && (
                <div
                  style={{
                    marginTop: '0px',
                    overflowX: 'auto',
                    minWidth: 'auto',
                    // borderTop: '1px solid #ddd',
                    paddingTop: '0px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      backgroundColor: '#D3D3D3',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="h6" style={{ paddingLeft: '6px', paddingRight: '6px' }}>
                      {forward ? 'Forward' : replyAll ? 'Reply All' : 'Reply'}
                    </Typography>
                    <img
                      src={deleteIcon}
                      alt="deleteMail"
                      height="24"
                      width="24"
                      onClick={handleClick}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>

                  <EmailComposer
                    textProps={textProps}
                    todata={todata}
                    setToData={setToData}
                    inputValue={inputValue}
                    setInputValue={setInputValue}
                    getSuggestions={getSuggestions}
                    ccData={ccData}
                    setCcData={setCcData}
                    ccInputValue={ccInputValue}
                    setCcInputValue={setCcInputValue}
                    setUsersValue={setUsersValue}
                    setCcUsersValue={setCcUsersValue}
                    subject={subject}
                    setSubject={setSubject}
                    content={content}
                    setContent={setContent}
                    attachments={attachments}
                    handleFileChange={handleFileChange}
                    removeAttachment={removeAttachment}
                    download={download}
                    sendInvite={sendInvite}
                  />
                </div>
              )}
              {/* Email Detail */}
              <div style={{ width: '100%' }}>
                <SentDetail
                  selectedEmail={selectedSentEmail}
                  formatDate={formatDate}
                  onClose={() => setSelectedSentEmail(null)}
                  sentItemProps={handleForwardMail}
                  replyAllProps={handleReplyAll}
                  replyProps={handleReply}
                />
              </div>
            </div>
          </Grid>
        )}
        {/* {showSent && selectedSentEmail && (
          <SentDetail
            selectedEmail={selectedSentEmail}
            formatDate={formatDate}
            onClose={() => setSelectedSentEmail(null)}
            sentItemProps={handleForwardMail}
          />
        )} */}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.form,
  state
});

const mapDispatchToProps = (dispatch) => ({
  UpdateFormField: (obj) => dispatch({ type: 'UpdateFormField', value: obj.value, name: obj.name }),
  clearForm: () => dispatch({ type: 'ClearForm' }),
  updateErrorObj: (obj) => dispatch({ type: 'updateErrorObj', flag: obj.flag, name: obj.name, text: obj.text }),
  updateEntireErrorObj: (errobj, errtextobj) => dispatch({ type: 'updateEntireErrorObj', errobj, errtextobj })
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Email));